import { colors } from "src/colors";

export const INPUT_STYLES = {
  h: "48px",
  borderColor: colors.grey[900],
  borderRadius: "8px",
  _focus: { boxShadow: "none", borderColor: colors.black[900] },
  _hover: { borderColor: colors.black[900] },
  border: "1px solid",
  _autofill: {
    boxShadow: "0 0 0px 1000px white inset"
  }
};

export const TEXTAREA_STYLES = {
  borderColor: colors.grey[900],
  borderRadius: "8px",
  _focus: { boxShadow: "none", borderColor: colors.black[900] },
  _hover: { borderColor: colors.black[900] },
  border: "1px solid"
};
